var $body = $('body');
$(document).ready(function () {
    if($('.landing-section').length){
        $('body').addClass('banner--active');
    }
    //Mobile Menu
    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('menu--open');
        nav_height();
    });
    $('.search-btn-desktop').on('click',function(){
        $('.search-menu-wrapper').slideDown();
        $('body').addClass('search--active');
    });
    $('.search-close').on('click',function(){
        $('.search-menu-wrapper').slideUp();
        $('body').removeClass('search--active');
    });

if (win_width() < 992) {
    $('.search-btn').on('click', function () {
        $(this).parents('.search-form').toggleClass('search--open');
        return false;
    });
    $('.second-level-menu > li.has-sub > .arrow').on('click',function(){
        $(this).parent().toggleClass("active").find(".third-level-menu").slideToggle();
        $(this).parent().siblings("li").removeClass("active").find(".third-level-menu").slideUp();
    });
   
}
else{
    $(".second-level-menu > li.has-sub > .arrow").on('click', function() {
        $(this).parents('.navigation').addClass('third-level--open');
        $(this).parent().siblings('li').removeClass('clicked');
        $(this).parent().toggleClass('clicked');
        return false;
    });
}

//Mega Menu

$('.navigation > nav > ul > li.has-sub > .arrow').on('click', function() {
    $(this).parent().siblings('li').removeClass('clicked');
    $(this).parent().siblings('li').toggleClass('md-hidden');
    $(this).parent().toggleClass('clicked');
    $(this).parents('.navigation').addClass('second-level--open');
    $(this).parent().find('.third-level--open').removeClass('third-level--open');
    return false;
});

$('.back-link .back-btn').on('click', function() {
    $(this).parents('.navigation').removeClass('second-level--open');
    $(this).parents().find('li').removeClass('clicked md-hidden');
    $(".second-level-menu > li.has-sub").removeClass("active").find(".third-level-menu").slideUp();
});

$('.back-link h4').on('click',function(){
    $(".second-level-menu > li.has-sub").removeClass("active").find(".third-level-menu").slideUp();
});


    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({scrollTop: 0}, 1000);
        return false;
    });
    //Headroom 
   
    if (win_width() > 992) {
        var myElement = document.querySelector("header");    
        var headroom  = new Headroom(myElement);    
        headroom.init();        
    }

  
    $(".accordion-title").on("click", function() {
        $(this).parent().toggleClass("active").find(".accordion-content").slideToggle();
    });
    $('.event-teaser').first().find('.event-list-content .event-info').addClass('active');
    $('.event-teaser').first().find('.read-more-content').slideDown();

    $(".event-list-content .read-more").on('click',function(){            
        $(this).parents('.event-info').find('.read-more-content').slideToggle();
        $(this).parents('.event-info').toggleClass('active');  
        if($('.event-info').hasClass('active')){
            $(this).parents('.event-info').find('.read-more').text('Weniger');
        }
        else{
            $(this).parents('.event-info').find('.read-more').text('Weiterlesen');
        }
    });

    $('.location-content .read-more').on('click',function(){
        $(this).parent().toggleClass('active');
        $(this).parent().find('.location-read-more').slideToggle();           
        return false;
    });
   
    $('[data-toggle="tooltip"]').tooltip();
    
    //Interlinking Menu
    $('.navigation a[href*=#]').bind('click', function (e) {
        e.preventDefault();
        var section = $(this).attr("href");
        $("html, body").animate({
            scrollTop: $(section).offset().top
        });
        $('body').removeClass('menu--open');
    });

    event_slider();
    location_slider();
    event_datepicker();
    image_textSlider();
    image_gallerySlider();

});

$(window).resize(function () {
    nav_height();
    event_slider();
    event_datepicker();
});

var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (win_width() > 992) {

    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
    } 
    else {
        $('.goto-top').removeClass('visible');
    }
   }
});
$(window).on('load',function(){
    setTimeout(function(){
        $(".info-accordion-image").addClass("is-active");
    }, 500);
   $('.accordion-block ').removeClass('active').$('.accordion-content').slideUp();
});

function nav_height() {
    if (win_width() < 992) {    
        $('.navigation').css('height', win_height() - header_height());
    }
    else{
        var menu_height = $('.navigation').height();
        $('.navigation nav').css('height', menu_height - 50);
    }
}
function win_height() {
    return $(window).outerHeight();
}
function win_width() {
    return $(window).width();
}
function header_height() {
    return $('header.page').outerHeight();
}
function event_slider(){
    if (win_width() < 768) {   
        if($('.event-slider').length){
            $('.event-slider').addClass('owl-carousel');
            var eventSlider = $('.event-slider.owl-carousel');
            if (eventSlider.find('.event-teaser').length > 1) {
                eventSlider.owlCarousel({
                    items: 1.3,
                    margin: 40,
                    loop: true,
                    dots: false,
                    autoplay: false,
                    nav: true,
                    autoplayTimeout: 5000,
                    onInitialize: function() {
                        if (eventSlider.find('.event-teaser').length === 1) {
                            this.settings.loop = false;
                            this.settings.nav = false;
                        }
                    }
                });
            }
        }
    }
}
function location_slider(){
     if($('.location-image-slider').length){
         var locationSlider = $('.location-image-slider.owl-carousel');
         if (locationSlider.find('.location-image-block').length > 1) {
            locationSlider.owlCarousel({
                items: 1,
                loop: true,
                dots: false,
                autoplay: false,
                nav: true,
                touchDrag:false,
                mouseDrag:false,
                onInitialize: function() {
                    if (locationSlider.find('.location-image-block').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        }
     }    
}
function event_datepicker(){
   
      if(win_width() < 768) {
        var selectedDates=[]
      dp = $(".event-date-picker").datepicker({
        format: "dd-mm-yyyy",
        multidate: true,
        inline: true,
        todayHighlight: false,
        daysOfWeekDisabled: [0],
        startDate: 'today'
      });    
      dp.on('changeDate', function(e) {        
        if(e.dates.length <3){
          selectedDates = e.dates
        }else{
          dp.data('datepicker').setDates(selectedDates);
          alert('Can only select 2 dates')
        }
       
      });
    }
     $('.event-date').datepicker({
        format: 'dd-mm-yyyy',
        orientation: "bottom auto"
     });
}
function image_textSlider(){
    if($('.image-text-slider-init').length){
        var imageTextSlider = $('.image-text-slider-init.owl-carousel');
        
            imageTextSlider.owlCarousel({              
               loop: false,
               dots: false,
               autoplay: false,
               nav: true,
               responsive : {
                0 : {
                   items: 1.2
                },
                768 : {
                    items: 2
                    
                },
                1200 : {
                  items:3
                }
            },
               onInitialize: function() {
                   if (imageTextSlider.find('.image-text-slide').length === 3) {
                       this.settings.loop = false;
                       this.settings.nav = false;
                   }                   
               }
           });
       
    }
   if(win_width()<768){
    $('.image-text-slider-init.owl-carousel .owl-next').on('click',function(){
        $('.image-text-slider-init.owl-carousel .owl-prev').addClass('active');
    });
   }
}
function image_gallerySlider (){
    if($('.image-gallery-slider-init').length){
        var imageGallerytSlider = $('.image-gallery-slider-init.owl-carousel');
        if (imageGallerytSlider.find('.image-gallery-block').length >= 4) {
            imageGallerytSlider.owlCarousel({
                center: true,
                items:1.5,
                loop:true,
                margin:25,
                dots:false,
                nav:true,
                autoplay:true,
                responsive:{
                    992:{
                        items:4
                    }
                }, 
                onInitialize: function() {
                    if (imageGallerytSlider.find('.image-gallery-block') === 4) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }                   
                }         
            });
        }
    }
}